import { ButtonGroup, ButtonVariants, FormControlSizes, HStack, SizeModeEnum, Text, ToggleButton } from '@talos/kyoko';

interface NettingSizeModeToggleProps {
  value: SizeModeEnum;
  canSelectUnits: boolean;
  disabled: boolean;
  onChange: (sizeMode: SizeModeEnum) => void;
}

const SIZE_MODE_OPTIONS = [
  { value: SizeModeEnum.Currency, label: 'Currency', testID: 'care-order-netting-size-mode-currency' },
  { value: SizeModeEnum.Units, label: 'Units', testID: 'care-order-netting-size-mode-units' },
];

export function NettingSizeModeToggle({ value, canSelectUnits, disabled, onChange }: NettingSizeModeToggleProps) {
  return (
    <HStack gap="spacing8" alignItems="center" data-testid="care-order-netting-size-mode-toggle">
      <Text size="fontSizeSm">Netted quantity in</Text>
      <ButtonGroup type="switch" size={FormControlSizes.Small} flex="0 0 auto" w="auto">
        {SIZE_MODE_OPTIONS.map(option => {
          const optionDisabled = disabled || (option.value === SizeModeEnum.Units && !canSelectUnits);

          return (
            <ToggleButton
              key={option.value}
              selected={value === option.value}
              selectedVariant={ButtonVariants.Priority}
              unselectedVariant={ButtonVariants.Muted}
              onClick={optionDisabled ? undefined : () => onChange(option.value)}
              data-testid={option.testID}
              disabled={optionDisabled}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
    </HStack>
  );
}
